import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Clock, Calendar, ChevronRight, Users } from "lucide-react";
import { TIMELINE } from "@/data/staticData";

export default function TimelinePage() {
  return (
    <div className="p-6 max-w-3xl mx-auto" data-testid="timeline-page">
      <div className="mb-8 animate-fade-in">
        <div className="flex items-center gap-3 mb-2">
          <Clock className="h-6 w-6 text-[var(--ia-navy)]" />
          <h1 className="text-2xl font-bold text-[var(--ia-text)]" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Timeline AI Act</h1>
        </div>
        <p className="text-[var(--ia-text-muted)]">Dates clés d'application du règlement européen sur l'IA</p>
      </div>

      <div className="relative">
        {/* Timeline line */}
        <div className="absolute left-6 top-0 bottom-0 w-px bg-[var(--ia-border)]" />

        <div className="space-y-6">
          {TIMELINE.map((item, i) => {
            const isPast = new Date(item.date.replace("Fevrier", "February").replace("Aout", "August")) <= new Date();
            return (
              <div key={i} className="relative pl-16 animate-fade-in" style={{ animationDelay: `${i * 100}ms` }} data-testid={`timeline-item-${i}`}>
                {/* Dot */}
                <div className={`absolute left-4 w-5 h-5 rounded-full border-2 ${isPast ? "bg-[var(--ia-navy)] border-[var(--ia-navy)]" : "bg-white border-[var(--ia-blue)]"}`} />

                <Card className="border-[var(--ia-border)]">
                  <Accordion type="single" collapsible>
                    <AccordionItem value={`tl-${i}`} className="border-none">
                      <AccordionTrigger className="px-5 py-4 hover:no-underline">
                        <div className="text-left">
                          <div className="flex items-center gap-2 mb-1">
                            <Badge variant={isPast ? "default" : "outline"} className={`text-xs ${isPast ? "bg-[var(--ia-navy)]" : ""}`}>
                              <Calendar className="h-3 w-3 mr-1" />{item.date}
                            </Badge>
                            {isPast && <Badge variant="outline" className="text-[10px] text-green-700 border-green-300 bg-green-50">En vigueur</Badge>}
                          </div>
                          <h3 className="font-semibold text-sm text-[var(--ia-text)]">{item.title}</h3>
                          <p className="text-xs text-[var(--ia-text-muted)] mt-0.5">{item.description}</p>
                        </div>
                      </AccordionTrigger>
                      <AccordionContent className="px-5 pb-4">
                        <div className="space-y-3 mt-1">
                          <div>
                            <h4 className="text-xs font-semibold text-[var(--ia-text)] mb-1">Impact</h4>
                            <p className="text-xs text-slate-600">{item.impact}</p>
                          </div>
                          <div>
                            <h4 className="text-xs font-semibold text-[var(--ia-text)] mb-1 flex items-center gap-1"><Users className="h-3 w-3" /> Secteurs concernes</h4>
                            <div className="flex flex-wrap gap-1">
                              {item.concerned.map((c, j) => <Badge key={j} variant="outline" className="text-[10px]">{c}</Badge>)}
                            </div>
                          </div>
                          <div>
                            <h4 className="text-xs font-semibold text-[var(--ia-text)] mb-1">Actions a mener</h4>
                            <ul className="space-y-1">
                              {item.actions.map((a, j) => (
                                <li key={j} className="text-xs text-slate-600 flex items-start gap-1.5">
                                  <ChevronRight className="h-3 w-3 text-[var(--ia-blue)] mt-0.5 flex-shrink-0" />{a}
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </AccordionContent>
                    </AccordionItem>
                  </Accordion>
                </Card>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
